import jquery from 'jquery';
import URL from '@/tools/url';
import { setupCsrfToken } from '@/ajax/shop/helpers/setupCsrfToken';

/**
 * @description
 * Отправка отзыва к товару
 *
 * @param {Object} review - объект с отзывом. ОБЯЗАТЕЛЬНО
 * @param {String} review.author - автор отзыва. ОБЯЗАТЕЛЬНО
 * @param {String} review.email - e-mail посетителя. ОБЯЗАТЕЛЬНО
 * @param {String} review.content - тело отзыва.ОБЯЗАТЕЛЬНО
 * @param {String} review.captcha_solution - капча. ОБЯЗАТЕЛЬНО
 * @param {String} review.captcha_challenge - капча. ОБЯЗАТЕЛЬНО
 * @param {String} productUrl - url товара, к которому хотим оставить отзыв
 * @param {Ibject} image_attributes][image - картинка
 *
 * @return {Promise} - поток выполнения задачи
 */
export default function(review, productUrl) {
  setupCsrfToken();
  var _result = jquery.Deferred();
  var _lang = URL.getKeyValue('lang') || '';

  var _review = {
    review: review,
    lang: _lang
  };
  var _reviewsUrl = productUrl + '/reviews.json';

  jquery.post(_reviewsUrl, _review)
    .done(function(response) {
      if (response.status == 'ok') {
        _result.resolve({ status: 'ok' });
      } else {
        _result.reject(response);
      }
    });

  return _result.promise();
}
